// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowThinUp: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="4" viewBox="0 0 9 4" fill="currentColor">
            <path
                fill="currentColor"
                d="M691.153972,1042.87966 C691.006995,1043.03689 690.769832,1043.03383 690.623816,1042.90666 L687.125066,1039.85233 L683.625847,1042.90694 C683.4713,1043.04051 683.234675,1043.02878 683.09569,1042.87994 C682.957878,1042.72966 682.9703,1042.50011 683.12405,1042.36602 L686.852956,1039.09322 C686.996511,1038.96893 687.211784,1038.96893 687.355456,1039.09322 L691.084363,1042.36602 C691.280534,1042.50011 691.292253,1042.72966 691.153972,1042.87966 L691.153972,1042.87966 Z"
                transform="translate(-683 -1039)"
            />
        </svg>
    );
};

export default React.memo(IconArrowThinUp);
